module.exports = __webpack_public_path__ + "static/work_Igrisca_loop-ace8476a49a232d787566c7418496eb2.mp4";